/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Duration_Too_LongInputs */

const en_us2_workout_after_duration_too_long = /** @type {(inputs: Workout_After_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too long`)
};

const pt_br2_workout_after_duration_too_long = /** @type {(inputs: Workout_After_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longa demais`)
};

const es_419_workout_after_duration_too_long = /** @type {(inputs: Workout_After_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy larga`)
};

const pt_pt2_workout_after_duration_too_long = /** @type {(inputs: Workout_After_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiado longa`)
};

const fr_fr2_workout_after_duration_too_long = /** @type {(inputs: Workout_After_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop longue`)
};

const de_de2_workout_after_duration_too_long = /** @type {(inputs: Workout_After_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu lang`)
};

const it_it2_workout_after_duration_too_long = /** @type {(inputs: Workout_After_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppo lunga`)
};

/**
* | output |
* | --- |
* | "Too long" |
*
* @param {Workout_After_Duration_Too_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_duration_too_long = /** @type {((inputs?: Workout_After_Duration_Too_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Duration_Too_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_duration_too_long(inputs)
	if (locale === "es-419") return es_419_workout_after_duration_too_long(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_duration_too_long(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_duration_too_long(inputs)
	if (locale === "de-DE") return de_de2_workout_after_duration_too_long(inputs)
	if (locale === "it-IT") return it_it2_workout_after_duration_too_long(inputs)
	return en_us2_workout_after_duration_too_long(inputs)
});
export { workout_after_duration_too_long as "workout-after.duration_too_long" }